// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"95bd0b6418451878e4a7","691":"5ce32955a6486e20054c"}[chunkId] + ".js";
};